import React from 'react'
import { makeStyles } from '@mui/styles'
import { components, DropdownIndicatorProps, GroupBase } from 'react-select'
import clsx from 'clsx'

import ThemeInterface from '@/theme-interface'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import TaxCategoryListIcon from '@assets/images/icons/menu_open.svg'
import lang from '@/lang'

const ICON_SIZE = '20px'

interface TaxCategoryListIndicatorProps {
  onClick: () => void
  dataQsId: string
  className?: string
}

export interface TaxCategorySelectProps {
  onOpenTaxCategoryList?: () => void
  taxCategoryListDataQsId?: string
}

const useStyles = makeStyles((theme: ThemeInterface) => ({
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    '& svg': {
      fill: theme.palette.text.secondary,
      transition: theme.transitions.create('fill'),
    },
    '&:hover svg, &:focus-visible svg': {
      fill: theme.palette.primary.main,
    },
  },
}))

export const TaxCategoryListIndicator = ({ onClick, dataQsId, className }: TaxCategoryListIndicatorProps) => {
  const classes = useStyles()

  return (
    <button
      type='button'
      className={clsx(classes.button, className)}
      title={lang.taxCategoryPositions.drawer.openAccountList}
      aria-label={lang.taxCategoryPositions.drawer.openAccountList}
      data-qs-id={dataQsId}
      onMouseDown={(event) => {
        event.preventDefault()
        event.stopPropagation()
      }}
      onTouchEnd={(event) => event.stopPropagation()}
      onClick={onClick}
    >
      <SVGIcon svg={TaxCategoryListIcon} width={ICON_SIZE} height={ICON_SIZE} />
    </button>
  )
}

export const TaxCategoryDropdownIndicator = <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: DropdownIndicatorProps<Option, IsMulti, Group>,
) => {
  const selectProps = props.selectProps as DropdownIndicatorProps<Option, IsMulti, Group>['selectProps'] & TaxCategorySelectProps
  const { isDisabled, onOpenTaxCategoryList, taxCategoryListDataQsId } = selectProps

  return (
    <>
      {onOpenTaxCategoryList && !isDisabled && (
        <TaxCategoryListIndicator
          onClick={onOpenTaxCategoryList}
          dataQsId={taxCategoryListDataQsId || 'taxCategoryListIndicator'}
        />
      )}
      <components.DropdownIndicator {...props} />
    </>
  )
}

export default TaxCategoryListIndicator
